<template>
    <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
        <div class="bg-[#1F1444] rounded-2xl w-[90%] p-5 text-white shadow-xl animate-[fadeIn_0.3s_ease-out_forwards]">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
};
</script>

<style scoped></style>
